/** Numero di un documento da mostrare. Il gestionale ha la serie vuota per
 * la maggior parte dei documenti, e il numero arriva come " /2025/03727" o
 * "/2025/03727": in pagina diventa "2025/03727". Solo per la visualizzazione:
 * chiavi e confronti usano il valore originale. */
export function numeroDocumento(numero?: string | null): string {
  return (numero || '').trim().replace(/^\/+/, '') || '—';
}

/** Il numero di un ordine del gestionale come lo vede il Cliente:
 *  "OW/2026/00048" (backend `erp.ordini.numero_gestionale`, INT-134). */
export function numeroGestionale(serie: string | null | undefined, anno: number, numdoc: number): string {
  return `${(serie || '').trim()}/${anno}/${String(numdoc).padStart(5, '0')}`;
}
